import * as React from 'react';

import { AuctionResponse } from '@types';
import BuyersSection from './BuyersSection';

interface Props {
  auction: AuctionResponse;
  isAuctionSecurity?: boolean;
  isAuctionSection?: boolean;
}

const AuctionSection: React.FC<Props> = (props) => {
  return (
    <div className="w-min-500 active-auction-panels">
      <BuyersSection
        auction={props.auction}
        isAuctionSection={props.isAuctionSection}
        isAuctionSecurity={props.isAuctionSecurity}
      />
    </div>
  );
};

export default AuctionSection;
